import { envConfig } from '@peerup/host-env'
/**
 * 从远程 CDN 获取数据
 * @param url - 远程数据 URL
 * @param options - 请求配置
 * @returns Promise<T> - 返回解析后的数据
 */
export async function fetchRemoteData<T>(
  url: string,
  options: Parameters<typeof fetch>[1] = {},
): Promise<T> {
  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return response.json()
  } catch (error) {
    console.error('Error fetching remote data:', error)
    throw error
  }
}

/**
 * 获取国际区号数据
 * @returns Promise<CountryOption[]> - 返回国际区号数据
 */
export async function fetchCountryOptions() {
  const lang = document.documentElement.lang || 'zh-CN'
  const STATIC_URL = `${envConfig.STATIC_URL}/static/country-options.${lang}.json`
  return fetchRemoteData<CountryOption[]>(STATIC_URL)
}

/**
 * 国际区号数据类型定义
 */
export type CountryOption = {
  label: string
  options: Array<{
    value: string
    label: string
  }>
}
